// Validates TPL input: allow only 'TBD' or numeric decimal value
// Accepts only pure numeric values (e.g., 144.05, 132) without suffixes
export function isValidTpl(value) {
  if (value === null || value === undefined) return true;
  const s = String(value).trim();
  if (s.length === 0) return true; // allow empty
  if (s.toUpperCase() === "TBD") return true;
  // Pattern: numeric only (with optional decimal), no suffixes allowed
  const tplPattern = /^\d+(?:\.\d+)?$/;
  return tplPattern.test(s);
}

// Optional sanitizer: normalize 'tbd' casing
export function normalizeTpl(value) {
  if (value === null || value === undefined) return value;
  const s = String(value).trim();
  if (s.toUpperCase() === "TBD") return "TBD";
  return s;
}